import style from "./Roadmap.module.scss";
import DottedLine from "../../../public/ico/dotted_line.svg";
import JoinIcon from "../../../public/ico/join_icon.svg";
import LinkIcon from "../../../public/ico/link_icon.svg";
import ContentIcon from "../../../public/ico/content_icon.svg";
import StatsIcon from "../../../public/ico/stats_icon.svg";
import BlueBlobs from "../../animate/BlueBlobs/BlueBlobs";

function Roadmap({ dictionary }) {
	return (
		<section className={style.container}>
			<h2 className={style.title} dangerouslySetInnerHTML={{ __html: dictionary["page_affiliate_header3"] || "It’s easy to apply and start earning cash" }} />
			<div className={style.cards}>
				<div className={style.left}>
					<div className={style.single}>
						<div className={style.card}>
							<p className={style.cardTitle}>
								<JoinIcon className={style.titleIcon} />
								{dictionary["page_affiliate_card1_header"] || "Apply to join"}
							</p>
							<p className={style.cardText}>
								{dictionary["page_affiliate_card1_descriptor"] ||
									"Enter basic information about your primary platform, audience/following, and how you plan to promote BgRem. It’s free to sign up, and there are no minimum sales required."}
							</p>
						</div>
					</div>
					<div className={style.double}>
						<DottedLine className={style.line} />
						<div className={style.card}>
							<p className={style.cardTitle}>
								<LinkIcon className={style.titleIcon} />
								{dictionary["page_affiliate_card2_header"] || "Get a custom link"}
							</p>
							<p className={style.cardText}>
								{dictionary["page_affiliate_card2_descriptor"] ||
									"Once you’re approved (it takes about a week), you’ll be able to generate a unique affiliate link to share on your website, YouTube, Instagram, TikTok or platform of choice."}
							</p>
						</div>
					</div>
				</div>
				<div className={style.right}>
					<div className={style.double}>
						<div className={style.card}>
							<p className={style.cardTitle}>
								<ContentIcon className={style.titleIcon} />
								{dictionary["page_affiliate_card3_header"] || "Create content with your affiliate link"}
							</p>
							<p className={style.cardText}>
								{dictionary["page_affiliate_card3_descriptor"] ||
									"The best affiliate partners create educational content that helps their audience understand what Generative AI is and then introduces them to BgRem. Share your link and tell them why you recommend BgRem."}
							</p>
						</div>
						<DottedLine className={`${style.line} ${style.rotate}`} />
					</div>
					<div className={style.double}>
						<DottedLine className={style.line} />
						<div className={style.card}>
							<p className={style.cardTitle}>
								<StatsIcon className={style.titleIcon} />
								{dictionary["page_affiliate_card4_header"] || "Earn rewards"}
							</p>
							<p className={style.cardText}>
								{dictionary["page_affiliate_card4_descriptor"] ||
									"For every new subscribers, you’ll earn 30% of all payments for the first 12 months — with no limits.It’s easy to generate multiple links and track your rewards through FirstPromoter."}
							</p>
						</div>
					</div>
				</div>
			</div>
			<BlueBlobs isBack={true} isBlur={true} />
		</section>
	);
}

export default Roadmap;
